import React, { useState, useEffect, useContext } from "react";
import { Box, Grid2, IconButton } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import MaterialSelect from "../../../components/MasterSelect";
import colors from "../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import MessagePopup from "../../Utils/MessagePopup";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import { UserContext } from "../../../pages/usercontext/usercontext";
import { postItem, updateItem, fetchAll } from "../../../BaseUrl";
import { GETCLIENT } from "../../Masters/ClientMaster/Mutation";
import { createuserstatus, updateuserstatus } from "../shortlisted/mutation";
import { getallpostion } from "../../Masters/PositionMaster/mutation";
import { getFormattedStatus } from "../../Utils/getFormattedStatus";

const AddInterview = ({
  formClose,
  editeddata,
  editedtrue,
  setEditedtrue,
  view,
  isview,
}) => {
  const { isuser } = useContext(UserContext);

  const statusoptions = [
    { label: "Selected", value: "selected" },
    { label: "Rejected", value: "rejected" },
    { label: "Hold", value: "hold" },
    { label: "Onboarded", value: "onboarded" },
  ];

  const [userdata, setuserdata] = useState({
    currentdate: "",
    hrname: isuser.username,
    candidatename: "",
    contactno: "",
    client: "",
    position: "",
    interviewdate: "",
    status: "",
    feedback: "",
    onboarddate: "",
    currentdateStatus: "unchecked",
    hrnameStatus: "unchecked",
    candidatenameStatus: "unchecked",
    contactnoStatus: "unchecked",
    clientStatus: "unchecked",
    positionStatus: "unchecked",
    interviewdateStatus: "unchecked",
    statusStatus: "unchecked",
    feedbackStatus: "unchecked",
    onboarddateStatus: "unchecked",
  });

  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [dialogOpen, setDialogOpen] = useState(false);

  const [clientoptions, setclientoptions] = useState([]);
  const [positionoptions, setpositionoptions] = useState([]);
  const [editid, setEditid] = useState(0);

  useEffect(() => {
    getcurrentdate();
    getClientData();
    getAllposition();
  }, []);

  useEffect(() => {
    if (editedtrue === true) {
      getdataforEdit();
      getcurrentdate();
    }
  }, [editedtrue]);

  const getdataforEdit = async () => {
    if (!editedtrue) return;

    setEditedtrue(false);

    const editedItem = editeddata[0];
    // Normalize the status (uppercase or mixed case with underscores) to lowercase
    const matchedStatus = {
      label: getFormattedStatus(editedItem?.status),
      value: editedItem.status.toLowerCase(),
    };

    const formatDate = (isoDate) => {
      if (!isoDate) return "";
      const [day, month, year] = isoDate.split("-");
      return `${year}-${month}-${day}`;
    };

    setTimeout(() => {
      setuserdata({
        ...userdata,
        // currentdate:'',
        hrname: editedItem?.createdBy,
        candidatename: editedItem.candidateName,
        contactno: editedItem.candidateNumber,
        client: {
          label: editedItem.clientName,
          value: editedItem.clientId,
        },
        position: {
          label: editedItem.positionName,
          value: editedItem.positionId,
        },
        interviewdate: formatDate(editedItem.interviewDate),
        status: matchedStatus,
        feedback: editedItem.interviewFeedback,
        currentdateStatus: "success",
        hrnameStatus: "success",
        candidatenameStatus: "success",
        contactnoStatus: "success",
        clientStatus: "success",
        positionStatus: "success",
        interviewdateStatus: "success",
        statusStatus: "success",
        feedbackStatus: "success",
      });
      setEditid(editedItem.id);
    }, 500);
  };

  const getAllposition = async () => {
    try {
      const response = await fetchAll(getallpostion);
      if (response?.getAllPositions?.success === true) {
        const data = response?.getAllPositions?.data.map((v, i) => ({
          value: v?.id,
          label: v?.positionName,
        }));
        setpositionoptions(data);
      } else {
        setpositionoptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const getcurrentdate = () => {
    const today = new Date().toISOString().split("T")[0];
    setuserdata({
      ...userdata,
      currentdate: today,
      currentdateStatus: "success",
    });
  };

  const getClientData = async () => {
    try {
      const response = await fetchAll(GETCLIENT);
      if (response?.getAllClients?.success === true) {
        const data = response?.getAllClients?.data.map((v, i) => ({
          value: v?.id,
          label: v?.clientName,
        }));
        setclientoptions(data);
      } else {
        setclientoptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const handleAddCourseChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...userdata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "client") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "position") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "status") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
          if (event?.value === "onboarded") {
            formState["feedback"] = "";
            formState["feedbackStatus"] = "unchecked";
          } else if (editeddata.length > 0) {
            formState["feedback"] = editeddata[0]?.interviewFeedback;
            formState["feedbackStatus"] = "success";
          }
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "candidatename":
          {
            const alphaNLengthRegex = new RegExp("^[a-zA-Z ]{1,50}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "feedback":
          {
            const alphaNLengthRegex = new RegExp("^.{1,30}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "contactno":
          {
            const alphaNLengthRegex = new RegExp("^.{1,10}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "interviewdate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "onboarddate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setuserdata(formState);
  };

  const hanldeConfirmDialogCancel = () => {
    setDialogOpen(false);
  };

  const hanldeConfirmDialogSubmit = async () => {
    try {
      if (editid == 0) {
        const variables = {
          input: {
            candidateNumber: userdata.contactno,
            candidateName: userdata.candidatename,
            client: userdata.client.value,
            position: userdata.position.value,
            interviewDate: userdata.interviewdate,
            hrUser: isuser.userid,
            status: userdata.status.value,
            interviewFeedback: userdata.feedback,
            onboardedFeedback: userdata.feedback,
            createdBy: isuser.username,
            onboardDate: userdata.onboarddate ? userdata.onboarddate : null,
          },
        };
        const response = await postItem(createuserstatus, variables);
        if (response.createScreening.success == true) {
          setPopup({
            ...popup,
            open: true,
            message: response.createScreening.message,
            severity: "success",
          });
          setDialogOpen(false);
          setTimeout(() => {
            reset();
          }, 1000);
        } else {
          setPopup({
            ...popup,
            open: true,
            message: response.createScreening.message,
            severity: "error",
          });
          setDialogOpen(false);
        }
      } else {
        const isTeamLeadOrHR = userdata?.status?.label === "Onboarded";

        const variables = {
          input: {
            id: editid,
            candidateNumber: userdata.contactno,
            candidateName: userdata.candidatename,
            client: userdata.client.value,
            position: userdata.position.value,
            interviewDate: userdata.interviewdate,
            onboardDate: userdata.onboarddate ? userdata.onboarddate : null,
            hrUser: isuser.userid,
            status: userdata.status.value,
            interviewFeedback:
              userdata.status.value === "onboarded"
                ? editeddata[0]?.interviewFeedback
                : userdata.feedback,
            onboardedFeedback:
              userdata.status.value === "onboarded" ? userdata.feedback : "",
            updatedBy: isuser.username,
            ...(isTeamLeadOrHR && { onboardDate: userdata.onboarddate ? userdata.onboarddate : null, }),
          },
        };
        const response = await updateItem(updateuserstatus, variables);
        if (response.updateScreening.success == true) {
          setPopup({
            ...popup,
            open: true,
            message: response.updateScreening.message,
            severity: "success",
          });
          setDialogOpen(false);
          setTimeout(() => {
            reset();
          }, 1000);
        } else {
          setPopup({
            ...popup,
            open: true,
            message: response.updateScreening.message,
            severity: "error",
          });
          setDialogOpen(false);
        }
      }
    } catch (error) {
      console.error(error, "error");
      setPopup({
        ...popup,
        open: true,
        message: "error in saving or updating the details",
        severity: "error",
      });
      setDialogOpen(false);
    } finally {
    }
  };

  const handleSubmit = () => {
    setDialogOpen(true);
  };

  const reset = () => {
    setuserdata({
      ...userdata,
      currentdate: "",
      hrname: "",
      candidatename: "",
      contactno: "",
      client: "",
      position: "",
      interviewdate: "",
      status: "",
      onboarddate: "",
      feedback: "",
      currentdateStatus: "unchecked",
      hrnameStatus: "unchecked",
      candidatenameStatus: "unchecked",
      contactnoStatus: "unchecked",
      clientStatus: "unchecked",
      positionStatus: "unchecked",
      interviewdateStatus: "unchecked",
      statusStatus: "unchecked",
      feedbackStatus: "unchecked",
      onboarddateStatus: "unchecked",
    });
    formClose();
    getcurrentdate();
  };

  const isFormValid = () => {
    if (userdata?.status?.label === "Onboarded") {
      return (
        userdata.currentdateStatus === "success" &&
        userdata.candidatenameStatus === "success" &&
        userdata.contactnoStatus === "success" &&
        userdata.clientStatus === "success" &&
        userdata.positionStatus === "success" &&
        userdata.interviewdateStatus === "success" &&
        userdata.statusStatus === "success" &&
        userdata.onboarddateStatus === "success" &&
        userdata.feedbackStatus === "success"
      );
    } else {
      return (
        userdata.currentdateStatus === "success" &&
        userdata.candidatenameStatus === "success" &&
        userdata.contactnoStatus === "success" &&
        userdata.clientStatus === "success" &&
        userdata.positionStatus === "success" &&
        userdata.interviewdateStatus === "success" &&
        userdata.statusStatus === "success" &&
        userdata.feedbackStatus === "success"
      );
    }
  };

  return (
    <>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title="Confirm Popup"
        content="Are you sure you want to submit this record?"
        onClose={hanldeConfirmDialogCancel}
        onConfirm={hanldeConfirmDialogSubmit}
      />
      <Box sx={{ p: 3, mx: "auto", borderRadius: 2 }}>
        <MessagePopup
          message={popup.message}
          severity={popup.severity}
          open={popup.open}
          setPopup={setPopup}
        />
        <ConfirmDialog
          open={dialogOpen}
          title="Confirm Popup"
          content="Are you sure you want to submit this record?"
          onClose={hanldeConfirmDialogCancel}
          onConfirm={hanldeConfirmDialogSubmit}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <IconButton onClick={formClose}>
              <ArrowBackIcon sx={{ color: "#000" }} />
            </IconButton>{" "}
            <MaterialTypography
              sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
              mb={2}
            >
              Add Candidate
            </MaterialTypography>
          </Box>
          <IconButton onClick={formClose}>
            <ClearIcon sx={{ color: "#000" }} />
          </IconButton>
        </Box>
        <Grid2 container spacing={1.5}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              HR Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="hrname"
              placeholder="Enter HR Name"
              value={userdata.hrname}
              onChange={handleAddCourseChange}
              error={userdata.hrnameStatus === "error" ? true : false}
              success={userdata.hrnameStatus === "success" ? true : false}
              disabled={true}
            />
            {userdata.hrnameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                HR Name must be 1 to 20 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Candidate Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="candidatename"
              placeholder="Enter Candidate Name"
              value={userdata.candidatename}
              onChange={handleAddCourseChange}
              error={userdata.candidatenameStatus === "error" ? true : false}
              success={
                userdata.candidatenameStatus === "success" ? true : false
              }
              disabled={view}
            />
            {userdata.candidatenameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Candidate Name must be 1 to 20 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Contact Number
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="contactno"
              placeholder="Enter Contact Number"
              value={userdata.contactno}
              onChange={(event) => {
                const value = event.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleAddCourseChange(event, null); // Call handler only if valid
                }
              }}
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                ];
                const isNumericKey = /^[0-9]$/.test(event.key);
                if (
                  (!isNumericKey && !allowedKeys.includes(event.key)) ||
                  (userdata.contactno &&
                    userdata.contactno.length >= 10 &&
                    isNumericKey)
                ) {
                  event.preventDefault(); // Prevent invalid or extra digits
                }
              }}
              error={userdata.contactnoStatus === "error" ? true : false}
              success={userdata.contactnoStatus === "success" ? true : false}
            />
            {userdata.contactnoStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Contact number should be 10 numeric characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Client
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="client"
              placeholder={`Select Client`}
              value={userdata.client}
              options={clientoptions}
              searchable={false}
              onChange={(selectedOption) => {
                handleAddCourseChange(selectedOption, { name: "client" })
                setuserdata((prev) => ({
                  ...prev,
                  position: "",
                  positionStatus: "unchecked", 
                }));
              }}
              error={userdata.clientStatus === "error" ? true : false}
              success={userdata.clientStatus === "success" ? true : false}
              isDisabled={view}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Position
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="position"
              placeholder={`Select Postion`}
              value={userdata.position}
              options={positionoptions}
              searchable={false}
              onChange={handleAddCourseChange}
              error={userdata.positionStatus === "error" ? true : false}
              success={userdata.positionStatus === "success" ? true : false}
              isDisabled={view}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Interview Date
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="interviewdate"
              placeholder="Enter DOB"
              type="date"
              value={userdata.interviewdate}
              onChange={handleAddCourseChange}
              error={userdata.interviewdateStatus === "error" ? true : false}
              success={
                userdata.interviewdateStatus === "success" ? true : false
              }
            />
            {userdata.interviewdateStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Interview date Should be DD-MM-YYYY.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Status
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="status"
              placeholder={`Select Status`}
              value={userdata.status}
              options={statusoptions}
              searchable={false}
              onChange={handleAddCourseChange}
              error={userdata.statusStatus === "error" ? true : false}
              success={userdata.statusStatus === "success" ? true : false}
              isDisabled={isview}
            />
          </Grid2>
          {userdata.status?.label == "Onboarded" && (
            <Grid2 size={{ xs: 12, md: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                sx={{ color: colors.inputlabel }}
              >
                OnBoarded Date
                <span style={{ marginLeft: "2px", color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                name="onboarddate"
                placeholder="Enter date"
                type="date"
                value={userdata.onboarddate}
                onChange={handleAddCourseChange}
                error={userdata.onboarddateStatus === "error" ? true : false}
                success={
                  userdata.onboarddateStatus === "success" ? true : false
                }
              />
              {userdata.onboarddateStatus === "error" && (
                <MaterialTypography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: "block" }}
                >
                  Onboarded date Should be DD-MM-YYYY.
                </MaterialTypography>
              )}
            </Grid2>
          )}
          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Feedback
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="feedback"
              placeholder="Enter Feedback"
              value={userdata.feedback}
              onChange={handleAddCourseChange}
              error={userdata.feedbackStatus === "error" ? true : false}
              success={userdata.feedbackStatus === "success" ? true : false}
            />
            {userdata.feedbackStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Feedback should 1 to 30 Variable characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12 }}>
            <Box display="flex" justifyContent="space-around" mt={3}>
              {isview == false && (
                <MaterialButton
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                >
                  Submit
                </MaterialButton>
              )}
              <MaterialButton onClick={reset} variant="outlined" color="error">
                Cancel
              </MaterialButton>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default AddInterview;
